export const Icon = ({ name, className = '', ...props }) => {
	return (
		<i className={`icon icon-${name} ${className}`} {...props} />
	)
}